"use client";
import React from "react";
import "./Dataset.css";
import { FaEdit } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
import AddDataset from "./AddModal/AddDataset";
import EditDataset from "./EditModal/EditDataset";
import DatasetLogic from "./DatasetLogic";
import { LuTriangle } from "react-icons/lu";
import { TbTriangleFilled, TbTriangleInvertedFilled } from "react-icons/tb";

function Dataset({ showIconsOnly }) {
  const {
    datasets,
    openAddModal,
    openEditModal,
    currentDataset,
    handleAddDataset,
    handleCloseAddModal,
    handleEditDataset,
    handleCloseEditModal,
    handleSaveDataset,
    currentPage,
    totalPages,
    handlePageChange,
    handlePageSizeChange,
    pageSize,
    totalRecords,
    startEntry,
    endEntry,
    search,
    setSearch,
    handleDatasetIdSort,
    sortMode
  } = DatasetLogic();

  return (
    <div className={`main-content ${showIconsOnly ? "icons-only" : ""}`}>
      {/* HEADER */}
      <div className="p-3 custom-bg-dataset rounded">
        <div className="d-flex justify-content-between align-items-center">
          <span className="m-0 title-dataset">Datasets</span>
          <button className="add-dataset-btn" onClick={handleAddDataset}>
            <IoMdAdd /> ADD DATASET
          </button>
        </div>
      </div>

      {/* SEARCH & PAGINATION */}
      <div className="mt-3 datasetlist-topbar">
        {/* SEARCH – LEFT */}
        <div className="datasetlist-search">
          <CiSearch className="datasetlist-search-icon" />
          <input
            type="text"
            placeholder="Search datasets"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* PAGINATION – RIGHT */}
        <div className=" datasetlist-pagination">
          <span className="datasetlist-showing-text">
            Showing {startEntry} to {endEntry} of {totalRecords} entries
          </span>

          <span>Show</span>
          <select
            className="form-select datasetlist-pagesize"
            value={pageSize}
            onChange={(e) => handlePageSizeChange(e.target.value)}
          >
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>


          <ul className="pagination-req">
            <li>
              <button
                className="page-btn-req"
                disabled={currentPage === 1 || totalRecords === 0}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                &lt;
              </button>
            </li>
            <li>
              <button className="page-btn-req page-btn-active">{currentPage}</button>
            </li>
            <li>
              <button
                className="page-btn-req"
                disabled={currentPage === totalPages || totalRecords === 0}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                &gt;
              </button>
            </li>
          </ul>

        </div>
      </div>


      {/* TABLE */}
      <div className="mt-4">
        <div className="table-content-dataset">
          <table className="dataset-table">
            <thead>
              <tr>
                <th onClick={handleDatasetIdSort} className="sortable-th">
                  <span className="th-content">
                    <span>Dataset Id</span>

                    {sortMode === null && <LuTriangle size={11} />}

                    {sortMode === "id-asc" && (
                      <TbTriangleFilled size={11} color="#EC6438" />
                    )}

                    {sortMode === "id-desc" && (
                      <TbTriangleInvertedFilled size={11} color="#EC6438" />
                    )}
                  </span>
                </th>

                <th>Display Name</th>
                <th>State</th>
                <th>Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {datasets.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    {search ? "No matching records found" : "No Records Found"}
                  </td>
                </tr>
              ) : (
                datasets.map((ds, index) => (
                  <tr key={index}>
                    <td>{ds.datasetID}</td>
                    <td>{ds.datasetDisplayName}</td>
                    <td>{ds.state}</td>
                    <td>{ds.entryType}</td>
                    <td>
                      <FaEdit
                        className="edit-icon-dataset"
                        onClick={() => handleEditDataset(ds)}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* MODALS */}
        {openAddModal && (
          <AddDataset onCancel={handleCloseAddModal} onSave={handleSaveDataset} />
        )}

        {openEditModal && currentDataset && (
          <EditDataset
            dataset={currentDataset}
            onSave={handleSaveDataset}
            onCancel={handleCloseEditModal}
          />
        )}
      </div>
    </div>
  );
}

export default Dataset;
